module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<div>\n<div class=\"table\">\n<table>\n<thead>\n<tr>\n<td colspan=\"3\" class=\"title\">\n<i class=\"fi fi-validator\"></i>\nValidatoren für Komponenten\n</td>\n</tr>\n<tr class=\"tableActions\">\n<td class=\"left\">\n<%- include('../form/elements/buttons/default', { formMapping: { buttonType: 'showInsert', context: 'validator', mode: '' } }) %>\n</td>\n<td colspan=\"2\" class=\"right\">\n<%\nvar m;\nvar exportButtons = ['copy', 'csv', 'excel', 'pdf', 'print'];\nfor(m in exportButtons){\n%><%- include('../form/elements/buttons/default', { formMapping: { buttonType: 'export', context: 'validator', mode: exportButtons[m] } }) %><%\n}\n%>\n</td>\n</tr>\n</thead>\n<tbody>\n<tr>\n<td colspan=\"3\" class=\"data\">\n<%\nif(model.fields){\n%>\n<table class=\"thead\">\n<colgroup>\n<%\nvar f;\nfor(f in model.fields){\n%>\n<col />\n<%\n}\n%>\n</colgroup>\n<tbody>\n<%\nif(config.showFilter){\nvar filterConfig = utils.simpleCopy(config);\nfilterConfig.isFilter = true;\n%>\n<%- include('./row', { config: filterConfig, model: model }); %>\n<%\n}\nvar headConfig = utils.simpleCopy(config);\nheadConfig.isHead = true;\n%>\n<%- include('./row', { config: headConfig, model: model }); %>\n</tbody>\n</table>\n<%\nif(resourceData.data){\nvar r, resources;\nif(Array.isArray(resourceData.data))    resources = resourceData.data;\nelse                                    resources = [resourceData.data];\nif(resources.length > 0){\n%>\n<table class=\"tbody\">\n<colgroup>\n<%\nvar f;\nfor(f in model.fields){\n%>\n<col />\n<%\n}\n%>\n</colgroup>\n<tbody>\n<%\nfor(r in resources){\nresources[r].rowIndex = r;\nif(r >= model.nrOfElementsPerPage) break;\n%>\n<%- include('./row', { config: config, resourceData: resources[r], model: model }); %>\n<%\n}\n%>\n</tbody>\n</table>\n<%\n}\n}\n}\n%>\n</td>\n</tr>\n<tr>\n<td colspan=\"3\" class=\"emptyTable <%- (model.nrOfElements > 0 ? '' : 'active') %>\">\nKeine Datensätze vorhanden\n</td>\n</tr>\n</tbody>\n<tfoot>\n<tr>\n<td class=\"pageingInfo\">\n<%- __('table.pageingInfo', { pageEntriesStart: '<span>' + Math.min(model.nrOfElements, (model.actualPage * model.nrOfElementsPerPage) + 1) + '</span>', pageEntriesEnd: '<span>' + Math.min(model.nrOfElements, ((model.actualPage + 1) * model.nrOfElementsPerPage)) + '</span>', nrOfElements: '<span class=\"nrOfElements\">' + model.nrOfElements + '</span>' }); %>\n</td>\n<td class=\"pagingNrOfElements\">\n<select>\n<%\nvar n;\nfor(n in config.nrOfElementsPerPage){\n%>\n<option value=\"<%- config.nrOfElementsPerPage[n] %>\"<%- (config.nrOfElementsPerPage[n] == model.nrOfElementsPerPage ? ' SELECTED' : '')%>><%= __('table.nrOfElementsPerPage', { nrOfElements: config.nrOfElementsPerPage[n] }) %></option>\n<%\n}\n%>\n</select>\n</td>\n<td class=\"pagingNavi\">\n<%\nif(model.nrOfPages > 1){\n%><button class=\"previous\">Vorige</button><%\nvar p;\nfor(p = 0; p < model.nrOfPages; p++){\n%><button class=\"<%- (model.actualPage == p ? 'selected' : '') %>\" data-page-index=\"<%- p %>\"><%= (p + 1) %></button><%\n}\n%><button class=\"next\">Nächste</button><%\n}\n%>\n</td>\n</tr>\n</tfoot>\n</table>\n</div>\n<div class=\"actionPanel\">\n<%- include('../form/elements/buttons/default', { formMapping: { buttonType: 'showInsert', context: 'validator', mode: '' } }) %>\n<%- include('../form/elements/buttons/default', { formMapping: { buttonType: 'showEdit', context: 'validator', mode: '' } }) %>\n<%- include('../form/elements/buttons/default', { formMapping: { buttonType: 'delete', context: 'validator', mode: '' } }) %>\n</div>\n</div>"
  , __filename = "node_modules/frontend-controller/baseComponents/table/table.ejs";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append("<div>\n<div class=\"table\">\n<table>\n<thead>\n<tr>\n<td colspan=\"3\" class=\"title\">\n<i class=\"fi fi-validator\"></i>\nValidatoren für Komponenten\n</td>\n</tr>\n<tr class=\"tableActions\">\n<td class=\"left\">\n")
    ; __line = 13
    ; __append( include('../form/elements/buttons/default', { formMapping: { buttonType: 'showInsert', context: 'validator', mode: '' } }) )
    ; __append("\n</td>\n<td colspan=\"2\" class=\"right\">\n")
    ; __line = 16
    ; 
var m;
var exportButtons = ['copy', 'csv', 'excel', 'pdf', 'print'];
for(m in exportButtons){

    ; __line = 20
    ; __append( include('../form/elements/buttons/default', { formMapping: { buttonType: 'export', context: 'validator', mode: exportButtons[m] } }) )
    ; 
}

    ; __line = 22
    ; __append("\n</td>\n</tr>\n</thead>\n<tbody>\n<tr>\n<td colspan=\"3\" class=\"data\">\n")
    ; __line = 29
    ; 
if(model.fields){

    ; __line = 31
    ; __append("\n<table class=\"thead\">\n<colgroup>\n")
    ; __line = 34
    ; 
var f;
for(f in model.fields){

    ; __line = 37
    ; __append("\n<col />\n")
    ; __line = 39
    ; 
}

    ; __line = 41
    ; __append("\n</colgroup>\n<tbody>\n")
    ; __line = 44
    ; 
if(config.showFilter){
var filterConfig = utils.simpleCopy(config);
filterConfig.isFilter = true;

    ; __line = 48
    ; __append("\n")
    ; __line = 49
    ; __append( include('./row', { config: filterConfig, model: model }) )
    ; __append("\n")
    ; __line = 50
    ; 
}
var headConfig = utils.simpleCopy(config);
headConfig.isHead = true;

    ; __line = 54
    ; __append("\n")
    ; __line = 55
    ; __append( include('./row', { config: headConfig, model: model }) )
    ; __append("\n</tbody>\n</table>\n")
    ; __line = 58
    ; 
if(resourceData.data){
var r, resources;
if(Array.isArray(resourceData.data))    resources = resourceData.data;
else                                    resources = [resourceData.data];
if(resources.length > 0){

    ; __line = 64
    ; __append("\n<table class=\"tbody\">\n<colgroup>\n")
    ; __line = 67
    ; 
var f;
for(f in model.fields){

    ; __line = 70
    ; __append("\n<col />\n")
    ; __line = 72
    ; 
}

    ; __line = 74
    ; __append("\n</colgroup>\n<tbody>\n")
    ; __line = 77
    ; 
for(r in resources){
resources[r].rowIndex = r;
if(r >= model.nrOfElementsPerPage) break;

    ; __line = 81
    ; __append("\n")
    ; __line = 82
    ; __append( include('./row', { config: config, resourceData: resources[r], model: model }) )
    ; __append("\n")
    ; __line = 83
    ; 
}

    ; __line = 85
    ; __append("\n</tbody>\n</table>\n")
    ; __line = 88
    ; 
}
}
}

    ; __line = 92
    ; __append("\n</td>\n</tr>\n<tr>\n<td colspan=\"3\" class=\"emptyTable ")
    ; __line = 96
    ; __append( (model.nrOfElements > 0 ? '' : 'active') )
    ; __append("\">\nKeine Datensätze vorhanden\n</td>\n</tr>\n</tbody>\n<tfoot>\n<tr>\n<td class=\"pageingInfo\">\n")
    ; __line = 104
    ; __append( __('table.pageingInfo', { pageEntriesStart: '<span>' + Math.min(model.nrOfElements, (model.actualPage * model.nrOfElementsPerPage) + 1) + '</span>', pageEntriesEnd: '<span>' + Math.min(model.nrOfElements, ((model.actualPage + 1) * model.nrOfElementsPerPage)) + '</span>', nrOfElements: '<span class="nrOfElements">' + model.nrOfElements + '</span>' }) )
    ; __append("\n</td>\n<td class=\"pagingNrOfElements\">\n<select>\n")
    ; __line = 108
    ; 
var n;
for(n in config.nrOfElementsPerPage){

    ; __line = 111
    ; __append("\n<option value=\"")
    ; __line = 112
    ; __append( config.nrOfElementsPerPage[n] )
    ; __append("\"")
    ; __append( (config.nrOfElementsPerPage[n] == model.nrOfElementsPerPage ? ' SELECTED' : ''))
    ; __append(">")
    ; __append(escapeFn( __('table.nrOfElementsPerPage', { nrOfElements: config.nrOfElementsPerPage[n] }) ))
    ; __append("</option>\n")
    ; __line = 113
    ; 
}

    ; __line = 115
    ; __append("\n</select>\n</td>\n<td class=\"pagingNavi\">\n")
    ; __line = 119
    ; 
if(model.nrOfPages > 1){

    ; __line = 121
    ; __append("<button class=\"previous\">Vorige</button>")
    ; 
var p;
for(p = 0; p < model.nrOfPages; p++){

    ; __line = 124
    ; __append("<button class=\"")
    ; __append( (model.actualPage == p ? 'selected' : '') )
    ; __append("\" data-page-index=\"")
    ; __append( p )
    ; __append("\">")
    ; __append(escapeFn( (p + 1) ))
    ; __append("</button>")
    ; 
}

    ; __line = 126
    ; __append("<button class=\"next\">Nächste</button>")
    ; 
}

    ; __line = 128
    ; __append("\n</td>\n</tr>\n</tfoot>\n</table>\n</div>\n<div class=\"actionPanel\">\n")
    ; __line = 135
    ; __append( include('../form/elements/buttons/default', { formMapping: { buttonType: 'showInsert', context: 'validator', mode: '' } }) )
    ; __append("\n")
    ; __line = 136
    ; __append( include('../form/elements/buttons/default', { formMapping: { buttonType: 'showEdit', context: 'validator', mode: '' } }) )
    ; __append("\n")
    ; __line = 137
    ; __append( include('../form/elements/buttons/default', { formMapping: { buttonType: 'delete', context: 'validator', mode: '' } }) )
    ; __append("\n</div>\n</div>")
    ; __line = 139
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL=node_modules/frontend-controller/baseComponents/table/table.ejs

}